<template>
  <v-carousel
    v-model="currentSlide"
    class="hero-carousel"
    cycle
    :interval="7000"
    hide-delimiter-background
    show-arrows-on-hover
    :show-arrows="!isMobile"
    transition="fade-transition"
    reverse-transition="fade-transition"
    :height="carouselHeight"
  >
    <v-carousel-item
      v-for="(item, i) in items"
      :key="`slider-item-${i}`"
    >
      <v-img
        :src="item.src"
        :lazy-src="item.preview"
        :alt="item.alt"
        eager
        cover
        class="slider-image"
        :aspect-ratio="aspectRatio"
      >
        <div class="overlay"></div>

        <!-- Texto opcional -->
        <!--
        <div class="content-overlay d-flex flex-column justify-center align-center text-center">
          <h2 class="content-title">{{ item.title }}</h2>
          <p class="content-subtitle">{{ item.subtitle }}</p>
        </div>
        -->
      </v-img>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'SliderComponent',

  data() {
    const base = process.env.VUE_APP_BASE_IMG;
    const version = new Date().getTime();

    const items = Array.from({ length: 3 }, (_, i) => ({
      src: `${base}/sliders/slider${i + 1}.jpg?v=${version}`,
      preview: `${base}/sliders/preview${i + 1}.jpg?v=${version}`,
      alt: `Promoción ${i + 1}`,
      title: `Slide ${i + 1}`,
      subtitle: 'Texto opcional'
    }));

    return {
      base,
      version,
      items,
      currentSlide: 0
    };
  },

  computed: {
    breakpoint() {
      return this.$vuetify?.breakpoint || {};
    },

    isMobile() {
      return this.breakpoint.xs || this.breakpoint.sm;
    },

    carouselHeight() {
      if (this.breakpoint.xs) return 180;
      if (this.breakpoint.sm) return 260;
      if (this.breakpoint.md) return 280;
      if (this.breakpoint.lg) return 380;
      return 360;
    },

    aspectRatio() {
      if (this.breakpoint.xs) return 16 / 9;
      return 21 / 8;
    }
  }
};
</script>

<style scoped>
.hero-carousel {
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.slider-image {
  width: 100%;
  height: 100%;
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.35) 0%,
    rgba(0, 0, 0, 0.15) 35%,
    rgba(0, 0, 0, 0.05) 100%
  );
}

.content-overlay {
  position: absolute;
  inset: 0;
  z-index: 2;
  padding: 24px;
  color: #fff;
}

.content-title {
  font-size: clamp(1.3rem, 2.5vw, 2.4rem);
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}

.content-subtitle {
  font-size: clamp(0.95rem, 1.5vw, 1.2rem);
  max-width: 700px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}

@media (max-width: 600px) {
  .hero-carousel {
    border-radius: 12px;
  }
}
</style>